"use client"

import clsx from "clsx"
import { useArrowKeys } from "./useArrowKeys"

export type NpColorSelectOption = { color: string; image?: undefined } | { color?: undefined; image: string }

export type NpColorSelectProps = {
  options: NpColorSelectOption[][]
  activeIndex: number
  onActiveIndexChange: (value: number) => void
}

export const NpColorSelect = ({ options, activeIndex, onActiveIndexChange }: NpColorSelectProps) => {
  const ref = useArrowKeys<HTMLButtonElement>((change) =>
    onActiveIndexChange((activeIndex + change + options.length) % options.length),
  )

  return (
    <button ref={ref} type="button" className="inline-flex items-center justify-center gap-2 rounded-full">
      {options.map((colors, index) => {
        const active = index === activeIndex

        return (
          <div
            key={index}
            onClick={() => onActiveIndexChange(index)}
            onKeyDown={undefined}
            className="group size-17 rounded-full p-1 outline-none"
          >
            <div
              className={clsx("flex size-full items-center justify-center rounded-full p-3 transition-all", {
                "group-hover:bg-np-green25": !active,
                "bg-np-green10": active,
              })}
            >
              <div className="flex size-full flex-col overflow-hidden rounded-full transition-opacity group-active:opacity-50">
                {colors.map((color, index) => {
                  return (
                    <div
                      key={index}
                      className="w-full flex-1"
                      style={{
                        backgroundImage: color.image ? `url(${color.image})` : undefined,
                        backgroundColor: color.color || "#fff",
                      }}
                    />
                  )
                })}
              </div>
            </div>
          </div>
        )
      })}
    </button>
  )
}
